export default {
  "buyingGuide.metaTitle": "USFans Shopping Guide: How to Browse & Buy",
  "buyingGuide.metaDescription": "A simple shopping guide for USFans — browse product categories, understand what to check, and head to the store with confidence.",
  "buyingGuide.badge": "Shopping Guide",
  "buyingGuide.h1": "Your USFans Shopping Guide",
  "buyingGuide.subtitle": "A quick, friendly walkthrough of the main product categories and what to keep in mind before you head to the store.",
  "buyingGuide.intro": "Shopping for USFans products is easier when you know where to look. Below you will find the main categories, a simple three-step path to buy, and answers to the most common questions.",
  "buyingGuide.stepsTitle": "How to Shop in Three Steps",
  "buyingGuide.step1.title": "Browse a Category",
  "buyingGuide.step1.text": "Pick a product category that interests you to see the available range.",
  "buyingGuide.step2.title": "Compare Details",
  "buyingGuide.step2.text": "Check price, seller and shipping information before you decide.",
  "buyingGuide.step3.title": "Head to the Store",
  "buyingGuide.step3.text": "Once you are ready, open the store and complete your order.",
  "buyingGuide.categoriesTitle": "Browse by Category",
  "buyingGuide.categoriesSubtitle": "Jump straight to any product category in the store.",
  "buyingGuide.storeTitle": "Ready to Shop?",
  "buyingGuide.storeText": "Open the official store to browse the full product range and place your order.",
  "buyingGuide.storeCta": "Visit the Store",
  "buyingGuide.faqTitle": "Common Questions",
  "buyingGuide.faq1.q": "How do I start shopping?",
  "buyingGuide.faq1.a": "Pick a category from the list above or head straight to the store to browse the full range.",
  "buyingGuide.faq2.q": "What should I check before buying?",
  "buyingGuide.faq2.a": "Review the price, seller and shipping details, and confirm the total cost before completing your order.",
  "buyingGuide.faq3.q": "Can I come back to these guides later?",
  "buyingGuide.faq3.a": "Yes. Return to the homepage anytime to browse guides, comparisons and safety tips alongside the product categories.",
  "buyingGuide.backHome": "Back to Home",
};